import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsFavoritesFuelStations = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/favorites${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  ADD: `/v1/fuelStations/favorites`,
  REMOVE: (id) => `/v1/fuelStations/favorites/${id}`,
}

export default endpointsFavoritesFuelStations
